"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFiltersData = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _ramda = require("ramda");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _v = _interopRequireDefault(require("uuid/v4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HOUR_RANGE_OPTIONS = [{
  content: '00:00 - 06:00',
  key: (0, _v.default)(),
  value: {
    from: 0,
    to: 6
  }
}, {
  content: '06:00 – 12:00',
  key: (0, _v.default)(),
  value: {
    from: 6,
    to: 12
  }
}, {
  content: '12:00 – 18:00',
  key: (0, _v.default)(),
  value: {
    from: 12,
    to: 18
  }
}, {
  content: '18:00 – 24:00',
  key: (0, _v.default)(),
  value: {
    from: 18,
    to: 24
  }
}];
var useFiltersData = exports.useFiltersData = function useFiltersData(_ref) {
  var countryID = _ref.countryID,
    offers = _ref.offers;
  var getOperatorsSelector = (0, _react.useMemo)(function () {
    return function (state) {
      return (0, _selectors.getOperatorsMap)()(state, {
        key: (0, _helpers.generateOperatorKey)(countryID, offers[0].departure)
      });
    };
  }, [countryID, offers]);
  var operatorsMap = (0, _reactRedux.useSelector)(getOperatorsSelector);
  var operators = (0, _react.useMemo)(function () {
    return (0, _ramda.call)((0, _ramda.pipe)((0, _ramda.groupBy)((0, _ramda.prop)('operator')), _ramda.values, (0, _ramda.map)(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        offer = _ref3[0];
      return operatorsMap === null || operatorsMap === void 0 ? void 0 : operatorsMap[offer.operator];
    }), (0, _ramda.filter)(Boolean), (0, _ramda.sort)(function (a, b) {
      return a.name.localeCompare(b.name);
    })), offers);
  }, [offers, operatorsMap]);
  var rooms = (0, _react.useMemo)(function () {
    return (0, _ramda.call)((0, _ramda.pipe)((0, _ramda.groupBy)((0, _ramda.path)(['room', 'id'])), _ramda.values, (0, _ramda.map)(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        offer = _ref5[0];
      return offer.room;
    }), (0, _ramda.sort)(function (a, b) {
      return a.name.localeCompare(b.name);
    })), offers);
  }, [offers]);
  return {
    hourRanges: HOUR_RANGE_OPTIONS,
    operators: operators,
    rooms: rooms
  };
};